import { Link } from "react-router-dom";

const BRANDS = [
  { name: "Admetec", country: "Israel", focus: "Loupes, headlights & intraoral cameras", text: "Hand-assembled optical systems engineered for precision dentistry. The Flamingo intraoral camera and ProLight LED set the global benchmark." },
  { name: "Medesy", country: "Italy", focus: "Surgical & periodontal instruments", text: "Forged in Maniago since 1979. Stainless steel surgical instruments trusted by dental schools worldwide." },
  { name: "Salli", country: "Finland", focus: "Ergonomic saddle seating", text: "Two-part saddle stools that protect spine health through long clinical days. The default choice for ergonomics-aware operatories." },
  { name: "Anya", country: "India", focus: "Premium dental chairs", text: "Made-in-India operatory chairs with European componentry. Solaris is the chair of choice for new-age clinics." },
  { name: "Wisedent", country: "Korea", focus: "3-in-1 multifunction units", text: "Compact scaler + polisher + curing units. The award-winning Wisedent unit consolidates three tools into one small footprint." },
  { name: "Gigaa", country: "Global", focus: "Soft-tissue diode lasers", text: "The Cheese Pro diode laser is the workhorse of laser-assisted dentistry — endo, periodontal, surgical." },
];

export default function Brands() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="overline">Brand directory</div>
      <h1 className="font-display text-5xl tracking-tight mt-3">Six brands. One vetted standard.</h1>
      <div className="mt-14 grid md:grid-cols-2 gap-8">
        {BRANDS.map((b) => (
          <Link key={b.name} to={`/products?brand=${encodeURIComponent(b.name)}`} data-testid={`brand-card-${b.name.toLowerCase()}`} className="fm-card p-8 block">
            <div className="flex items-baseline justify-between">
              <div className="font-display text-3xl tracking-tight">{b.name}</div>
              <div className="overline text-[var(--fm-accent)]">{b.country}</div>
            </div>
            <div className="overline mt-2">{b.focus}</div>
            <p className="text-sm text-[var(--fm-text-2)] mt-4 leading-relaxed">{b.text}</p>
            <div className="text-xs text-[var(--fm-primary)] mt-6 inline-block border-b border-[var(--fm-primary)] pb-0.5">View catalogue →</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
